export default __webpack_public_path__ + "static/media/search-white.9d52499d.svg";